import { render, staticRenderFns } from "./LastUpdate.vue?vue&type=template&id=7679a653&scoped=true"
import script from "./LastUpdate.ts?vue&type=script&lang=ts&external"
export * from "./LastUpdate.ts?vue&type=script&lang=ts&external"
import style0 from "./LastUpdate.vue?vue&type=style&index=0&id=7679a653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7679a653",
  null
  
)

export default component.exports